import { render } from "./OnlineConfirm.vue?vue&type=template&id=6db6b8fc&scoped=true&ts=true"
import script from "./OnlineConfirm.vue?vue&type=script&lang=ts"
export * from "./OnlineConfirm.vue?vue&type=script&lang=ts"

import "./OnlineConfirm.vue?vue&type=style&index=0&id=6db6b8fc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db6b8fc"]])

export default __exports__